var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header',[_vm._t("header")],2),_vm._v(" "),_c('main',[_vm._l((_vm.news),function(item){return _c('h1',[_vm._v("这是我的子组件"+_vm._s(item.username))])}),_vm._v(" "),_vm._t("default",[_vm._v("\n            只有在没有要分发的内容时才会显示。\n        ")])],2),_vm._v(" "),_c('footer',[_vm._t("footer")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05a3884c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SendMessage.vue
// module id = null
// module chunks = 